import { useThemeState } from "../theme";

// Le logo de la barre du haut. Les habillages livrés avec leur propre lettrage
// le posent ici à la place du logo maison ; les autres gardent le PNG.
// Les couleurs viennent des variables du thème (themes/*.css) : le même dessin
// sert en clair et en sombre.

function FrutigerMark() {
  return (
    <svg viewBox="0 0 240 152" class="app-mark app-mark-frutiger" role="img" aria-label="PopuQuiz">
      <defs>
        <linearGradient id="pqAeroWord" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="var(--fa-word-1)" />
          <stop offset=".42" stop-color="var(--fa-word-2)" />
          <stop offset="1" stop-color="var(--fa-word-3)" />
        </linearGradient>
      </defs>
      <g transform="rotate(-5 120 56)">
        <text x="120" y="74" class="fa-mark-halo fa-mark-popu">POPU</text>
        <text x="120" y="74" class="fa-mark-face fa-mark-popu">POPU</text>
      </g>
      <g transform="rotate(3 120 114)">
        <text x="120" y="132" class="fa-mark-halo fa-mark-quiz">QUIZ</text>
        <text x="120" y="132" class="fa-mark-face fa-mark-quiz">QUIZ</text>
      </g>
      {/* Les éclats du logo maison deviennent des bulles, et l'un d'eux une feuille. */}
      <circle cx="24" cy="30" r="10" fill="none" stroke="var(--fa-halo)" stroke-width="3" opacity=".9" />
      <circle cx="20" cy="26" r="3" fill="var(--fa-halo)" />
      <circle cx="216" cy="44" r="7" fill="none" stroke="var(--fa-halo)" stroke-width="3" opacity=".85" />
      <circle cx="200" cy="16" r="4" fill="var(--fa-halo)" opacity=".85" />
      <circle cx="14" cy="116" r="5" fill="none" stroke="var(--fa-halo)" stroke-width="3" opacity=".7" />
      <path d="M204 120 q16 -12 30 2 q-16 14 -30 -2z" fill="var(--fa-leaf)" stroke="var(--fa-ink)" stroke-width="4"
        stroke-linejoin="round" />
      <path d="M226 122 q-8 2 -14 -2" fill="none" stroke="var(--fa-ink)" stroke-width="3" />
    </svg>
  );
}

// Deux tubes, deux couleurs, décalés — comme une enseigne montée à la main.
function NeonMark() {
  return (
    <span class="app-mark app-mark-neon" role="img" aria-label="PopuQuiz">
      <span class="app-mark-neon-1">Popu</span>
      <span class="app-mark-neon-2">Quiz</span>
    </span>
  );
}

// Décalcomanie de kit : jaune décal en haut, plastique blanc en bas, contour
// gunmetal, et les crochets d'angle d'un réticule à la place des éclats.
function GundamMark() {
  return (
    <svg viewBox="0 0 240 152" class="app-mark app-mark-gundam" role="img" aria-label="PopuQuiz">
      <g transform="rotate(-5 120 56)">
        <text x="120" y="74" class="gd-mark-halo gd-mark-popu">POPU</text>
        <text x="120" y="74" class="gd-mark-face gd-mark-popu">POPU</text>
      </g>
      <g transform="rotate(3 120 114)">
        <text x="120" y="132" class="gd-mark-halo gd-mark-quiz">QUIZ</text>
        <text x="120" y="132" class="gd-mark-face gd-mark-quiz">QUIZ</text>
      </g>
      <g class="gd-mark-reticle" fill="none" stroke-width="3">
        <path d="M4 20 30 20" />
        <path d="M236 26 210 26" />
        <path d="M4 20 4 34" />
        <path d="M236 26 236 40" />
      </g>
      <path class="gd-mark-rule" d="M0 108 240 108" fill="none" stroke-width="1" />
    </svg>
  );
}

// Pochoir sur le mur : deux tons de jaune sale, contour encre, auréole
// d'humidité derrière.
function BackroomsMark() {
  return (
    <svg viewBox="0 0 240 152" class="app-mark app-mark-backrooms" role="img" aria-label="PopuQuiz">
      <ellipse class="br-mark-stain" cx="130" cy="96" rx="112" ry="52" />
      <g transform="rotate(-5 120 56)">
        <text x="120" y="74" class="br-mark-halo br-mark-popu">POPU</text>
        <text x="120" y="74" class="br-mark-face br-mark-popu">POPU</text>
      </g>
      <g transform="rotate(3 120 114)">
        <text x="120" y="132" class="br-mark-halo br-mark-quiz">QUIZ</text>
        <text x="120" y="132" class="br-mark-face br-mark-quiz">QUIZ</text>
      </g>
      {/* Les éclats du logo maison deviennent quatre traits de néon. */}
      <g class="br-mark-neon" fill="none" stroke-width="5" stroke-linecap="round">
        <path d="M16 30 4 20" />
        <path d="M224 36 236 26" />
        <path d="M10 104 0 110" />
        <path d="M230 110 240 116" />
      </g>
    </svg>
  );
}

// Une graisse énorme sur sa plaque crème.
function SeventiesMark() {
  return (
    <span class="app-mark app-mark-seventies" role="img" aria-label="PopuQuiz">
      <span class="sv-mark-plate">
        <span class="sv-mark-1">Popu</span>
        <span class="sv-mark-2">Quiz</span>
      </span>
    </span>
  );
}

// Graisse pleine sur sa plaque cernée, ombre dure en diagonale.
function EightiesMark() {
  return (
    <span class="app-mark app-mark-eighties" role="img" aria-label="PopuQuiz">
      <span class="ei-mark-plate">
        <span class="ei-mark-1">Popu</span>
        <span class="ei-mark-2">Quiz</span>
      </span>
    </span>
  );
}

// L'étiquette du paquet, barrée de son ruban croisé.
function NoelMark() {
  return (
    <span class="app-mark app-mark-noel" role="img" aria-label="PopuQuiz">
      <span class="no-mark-tag">
        <span class="no-mark-1">Popu</span>
        <span class="no-mark-2">Quiz</span>
      </span>
    </span>
  );
}

// Le panneau émaillé vissé au mur du bassin.
function PiscineMark() {
  return (
    <span class="app-mark app-mark-piscine" role="img" aria-label="PopuQuiz">
      <span class="pi-mark-plate">
        <span class="pi-mark-1">Popu</span>
        <span class="pi-mark-2">Quiz</span>
      </span>
    </span>
  );
}

// La pancarte du jeu : le mot gravé, « Quiz » décalé d'un bloc.
function MinecraftMark() {
  return (
    <span class="app-mark app-mark-minecraft" role="img" aria-label="PopuQuiz">
      <span class="mc-mark-1">Popu</span>
      <span class="mc-mark-2">Quiz</span>
    </span>
  );
}

// La pancarte clouée au portail de la ferme, « Quiz » décalé comme une
// planche mal ajustée.
function StardewMark() {
  return (
    <span class="app-mark app-mark-stardew" role="img" aria-label="PopuQuiz">
      <span class="sd-mark-1">Popu</span>
      <span class="sd-mark-2">Quiz</span>
    </span>
  );
}

// Le mot creusé dans une tache d'encre noire.
function SplatoonMark() {
  return (
    <span class="app-mark app-mark-splatoon" role="img" aria-label="PopuQuiz">
      <span class="spl-mark-1">Popu</span>
      <span class="spl-mark-2">Quiz</span>
    </span>
  );
}

// Le lettrage en laine teinte : un halo crème, l'aplat cerné de cocoa, puis le
// tracé repassé au point de faufil. Les éclats deviennent des bouts de fil.
function CrochetMark() {
  const word = (y, cls, text) => (
    <>
      <text x="120" y={y} class={`cr-mark-halo ${cls}`}>{text}</text>
      <text x="120" y={y} class={`cr-mark-face ${cls}`}>{text}</text>
      <text x="120" y={y} class={`cr-mark-stitch ${cls}`}>{text}</text>
    </>
  );
  return (
    <svg viewBox="0 0 240 152" class="app-mark app-mark-crochet" role="img" aria-label="PopuQuiz">
      <g transform="rotate(-5 120 56)">{word(74, "cr-mark-popu", "POPU")}</g>
      <g transform="rotate(3 120 114)">{word(132, "cr-mark-quiz", "QUIZ")}</g>
      <g class="cr-mark-thread" fill="none" stroke-width="4" stroke-linecap="round">
        <path d="M18 26 q9 -10 18 0" />
        <path d="M206 30 q9 -10 18 0" />
        <path d="M8 110 q9 -10 18 0" />
      </g>
    </svg>
  );
}

// L'enseigne de la Séance : le mot en Limelight sur un siège rouge, posé sur
// son ombre dure oxblood, le liseré beurre sous les lettres.
function PopuwatchMark() {
  return <span class="app-mark app-mark-popuwatch" role="img" aria-label="PopuQuiz">PopuQuiz</span>;
}

const MARKS = {
  popuwatch: PopuwatchMark,
  stardew: StardewMark,
  splatoon: SplatoonMark,
  crochet: CrochetMark,
  minecraft: MinecraftMark,
  frutiger: FrutigerMark,
  seventies: SeventiesMark,
  eighties: EightiesMark,
  noel: NoelMark,
  piscine: PiscineMark,
  neon: NeonMark,
  gundam: GundamMark,
  backrooms: BackroomsMark,
};

export default function ThemeLogo() {
  const { theme } = useThemeState();
  const Mark = MARKS[theme];
  if (Mark) return <Mark />;
  return <img src="../logo512.png" alt="PopuQuiz Logo" class="logo" />;
}

// Le lettrage d'un habillage donné, hors de la barre : boutique et réglages
// montrent ainsi chaque thème par son propre logo. Les couleurs viennent de
// `.thm-mark[data-mark-theme]` (themes/*.css), posé sur l'enveloppe : elles ne
// dépendent donc pas de l'habillage actif.
export function ThemeMark({ theme, name }) {
  const Mark = MARKS[theme];
  return (
    <span class="thm-mark" data-mark-theme={theme}>
      {Mark ? <Mark /> : <span class="thm-mark-wordmark">{name || theme}</span>}
    </span>
  );
}
// Vrai si l'habillage a son propre lettrage — les autres se présentent par leur
// nom, jamais par le logo d'un voisin.
export function hasThemeMark(theme) {
  return Boolean(MARKS[theme]);
}
